"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCarousels = exports.CATEGORY_CAROUSELS_PRODUCT_CATEGORY_SELECT = exports.CATEGORY_CAROUSELS_QUERY = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const CategoryCarouselsView_1 = require("./views/CategoryCarouselsView");
exports.CATEGORY_CAROUSELS_QUERY = 'getProductCategories';
exports.CATEGORY_CAROUSELS_PRODUCT_CATEGORY_SELECT = {
    slug: true,
    title: true,
    description: true,
    products: {
        title: true,
        images: true,
        slug: true,
    },
};
function CategoryCarousels() {
    const { data: categories } = (0, app_1.useQuery)('getProductCategories', {
        select: exports.CATEGORY_CAROUSELS_PRODUCT_CATEGORY_SELECT,
    });
    return (0, jsx_runtime_1.jsx)(CategoryCarouselsView_1.CategoryCarouselsView, { categories: categories !== null && categories !== void 0 ? categories : [] });
}
exports.CategoryCarousels = CategoryCarousels;
